import store from './store/index';

export default {
  name: 'ui',
  store,
  routes: [],
};
